import * as React from 'react'

import type { Field } from 'factorial-form'
import { AllowanceFragment, TimeoffAllowanceAllowanceTypeEnum } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Inputs/Select'
import i18n from 'modules/core/lib/i18n'

export interface AllowanceOption {
  id: string
  allowanceType: TimeoffAllowanceAllowanceTypeEnum
  name: string
}

interface Props {
  field: Field
  allowances: AllowanceOption[] | []
  allowanceToDelete?: AllowanceFragment | null
  handleMoveIncidences?: (value: boolean) => void
}

const AllowanceSelector = ({
  field,
  allowanceToDelete,
  allowances,
  handleMoveIncidences,
}: Props) => {
  const options = allowances
    .filter((a) => a.id !== allowanceToDelete?.id)
    .map((a) => ({
      label: a.name,
      value: a.id,
    }))

  const findSelectedAllowanceType = (allowanceId: string): string => {
    const allowance = allowances.find((a) => a.id === allowanceId)

    return allowance?.allowanceType || ''
  }

  const handleOnChange = (field: Field) => {
    if (allowanceToDelete && handleMoveIncidences) {
      const allowanceToDeleteType = allowanceToDelete?.allowanceType
      const selectedAllowanceType = findSelectedAllowanceType(field.value)

      if (allowanceToDeleteType !== selectedAllowanceType) {
        handleMoveIncidences(true)
      } else {
        handleMoveIncidences(false)
      }
    }
  }

  return (
    <Select
      label={i18n.t('common.timeoff_allowance')}
      options={options}
      field={field}
      defaultOption={
        field.value
          ? null
          : {
              value: '',
              label: i18n.t('common.select'),
            }
      }
      showOriginalLabelText
      mandatory
      onChange={handleOnChange}
      extra={{ 'data-intercom-target': 'timeoff-allowance-selector' }}
    />
  )
}

export default observer(AllowanceSelector)
